import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getWithdrawFailed} from '../../../apis/withdraw/withdrawFailed'

const useQueryWithdrawFailed = () => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.other.getWithdrawFailed(),
        queryFn: async () => {
            const {data, pageInfo} = await getWithdrawFailed()
            return {data, pageInfo}
        },
    })

    return {data, refetch}
}

export default useQueryWithdrawFailed
